import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_DIRECTIONS_PRESCRIPTRICES_PRINCIPALES} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    directionsPrescriptricesPrincipales: []
  },

  getAll() {
    if (this.state.directionsPrescriptricesPrincipales.length === 0) {
      return axios.get(ENDPOINT_DIRECTIONS_PRESCRIPTRICES_PRINCIPALES)
          .then(response => {
            this.state.directionsPrescriptricesPrincipales = response.data;
            return this.state.directionsPrescriptricesPrincipales;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.directionsPrescriptricesPrincipales);
      });
    }
  }
};

export default store;
